import { render, staticRenderFns } from "./RecipeInput.vue?vue&type=template&id=247dedd1&scoped=true"
import script from "./RecipeInput.vue?vue&type=script&lang=js"
export * from "./RecipeInput.vue?vue&type=script&lang=js"
import style0 from "./RecipeInput.vue?vue&type=style&index=0&id=247dedd1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "247dedd1",
  null
  
)

export default component.exports